<template>
  <div v-loading="loading" class="custom-bar" ref="myChart"></div>
</template>

<script>
import echarts from 'echarts'
export default {
  name: 'CustomBar',
  data() {
    return {}
  },
  props: {
    options: {
      type: Object
    },
    series: {
      type: String
    },
    loading: {
      type: Boolean
    }
  },
  mounted() {
    this.myChart = echarts.init(this.$refs.myChart)
    this.myChart.setOption(this.barOptions)
    this.myChart.resize()
    this.myChart.on('click', params => {
      this.$emit('barClick', params, this.series)
    })
  },
  computed: {
    barOptions() {
      return {
        title: {
          text: this.options.title,
          textStyle: {
            fontSize: 14
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          right: 0,
          orient: 'vertical',
          data: this.options.legend
        },
        grid: {
          containLabel: true,
          show: false // 网格边框是否显示，上和右边框
        },
        xAxis: this.options.xAxis,
        yAxis: this.options.yAxis,
        series: this.options.series
      }
    }
  },
  watch: {
    options: {
      handler() {
        this.myChart.setOption(this.barOptions)
        this.myChart.resize()
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus" scoped>
.custom-bar {
  height: 450px;
}
</style>
